export default __webpack_public_path__ + "static/media/img-trabajo-6.68134d98.jpg";